/* GHALIA — Our Materials page: photo accordion */
(function () {
  const $ = (sel, ctx) => (ctx || document).querySelector(sel);
  const $$ = (sel, ctx) => [...(ctx || document).querySelectorAll(sel)];

  const root = $('[data-materials]');
  if (!root) return;

  const items = $$('[data-mat-item]', root);
  const accordion = $('[data-mat-accordion]', root);
  const oneAtATime = accordion?.dataset.oneAtATime !== 'false';

  const setOpen = (item, open) => {
    const trigger = $('[data-mat-trigger]', item);
    const panel = $('[data-mat-panel]', item);
    if (!trigger || !panel) return;

    item.classList.toggle('is-open', open);
    trigger.setAttribute('aria-expanded', open ? 'true' : 'false');

    if (open) {
      panel.hidden = false;
    } else {
      const onEnd = (e) => {
        if (e.propertyName !== 'grid-template-rows') return;
        panel.removeEventListener('transitionend', onEnd);
        if (!item.classList.contains('is-open')) panel.hidden = true;
      };
      panel.addEventListener('transitionend', onEnd);
    }
  };

  items.forEach((item) => {
    const trigger = $('[data-mat-trigger]', item);
    if (!trigger) return;

    trigger.addEventListener('click', () => {
      const willOpen = !item.classList.contains('is-open');

      if (willOpen && oneAtATime) {
        items.forEach((other) => {
          if (other !== item && other.classList.contains('is-open')) {
            setOpen(other, false);
          }
        });
      }

      setOpen(item, willOpen);

      if (willOpen) {
        window.requestAnimationFrame(() => {
          item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
        });
      }
    });
  });

  /* Reveal on scroll — hero + staggered material cards */
  if ('IntersectionObserver' in window) {
    const revealIo = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const el = entry.target;
          const delay = el.dataset.revealDelay;
          if (delay) {
            el.style.transitionDelay = `${delay}ms`;
          }
          el.classList.add('is-in');
          revealIo.unobserve(el);
        });
      },
      { threshold: 0.1, rootMargin: '0px 0px -40px 0px' }
    );

    $$('[data-reveal]', root).forEach((el) => revealIo.observe(el));
    items.forEach((item, i) => {
      item.dataset.reveal = '';
      item.dataset.revealDelay = String(Math.min(i * 70, 350));
      revealIo.observe(item);
    });
  } else {
    $$('[data-reveal]', root).forEach((el) => el.classList.add('is-in'));
    items.forEach((el) => el.classList.add('is-in'));
  }
})();
